import { useCallback, useLayoutEffect, useState } from 'react';

import { useMarkBankMessagesAsRead } from '@shared/bank-messages-utils';
import { logger } from '@luna/logger';
import type { BankMessage } from '@shared/bank-messages-utils';

import { filterUnreadMessages, removeMessageFromArray } from './MustReadMessagesService';
import { useMandatoryMessages } from './useMandatoryMessages';

export const useMustReadMessages = () => {
    const [mustReadMessages, setMustReadMessages] = useState<BankMessage[]>([]);

    const { data: mandatoryMessages, isPending, error, refetch } = useMandatoryMessages();
    const { mutate: markBankMessageAsRead } = useMarkBankMessagesAsRead();

    const markMessageAsRead = useCallback(
        (messageId: string) => {
            setMustReadMessages(removeMessageFromArray(mustReadMessages, messageId));

            return markBankMessageAsRead([messageId]).catch(logger.error);
        },
        [markBankMessageAsRead, mustReadMessages],
    );

    useLayoutEffect(() => {
        setMustReadMessages(filterUnreadMessages(mandatoryMessages));
    }, [mandatoryMessages]);

    return {
        isPending,
        error,
        mustReadMessages,
        refetch,
        markMessageAsRead,
    };
};
